import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const StatusName = styled.span`
    width: 100px;

    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    line-height: 20px;
    color: ${Colors.Black.V50};
`;

export const lensFilterItemContainer = css`
    cursor: pointer;
    width: 142px;

    &:not(:last-of-type) {
        margin-bottom: 20px;
    }

    .sds-checkbox-wrapper .rc-checkbox .rc-checkbox-inner {
        width: 16px;
        height: 16px;
        border-radius: 4px;
    }

    .sds-checkbox-wrapper .rc-checkbox .rc-checkbox-inner:after {
        top: 1px;
        left: 3.5px;
        width: 5px;
        height: 7px;
    }
`;

export const separator = css`
    margin: ${Spacing.MD}px 0;
`;

export const widthName = css`
    width: 112px;
`;
